const SIDEBAR_MODEL = [
    {
      id: 'acco_inventarisierung',
      label: 'Informationen',
      fudkeys: [],
      transcriptButtonEnable: false,
      transcriptButtonChecked: false,
      kategorieButtonEnable: false,
      kategorieButtonChecked: false
    },
    {
      id: 'acco_transkription',
      label: 'Transkription',
      fudkeys: [],
      transcriptButtonEnable: false,
      transcriptButtonChecked: false,
      kategorieButtonEnable: false,
      kategorieButtonChecked: false
    },
    {
      id: 'acco_einzelstellenkommentare',
      label: 'Einzelstellenkommentare',
      fudkeys: ['WebAnmerkung'],
      transcriptButtonEnable: true,
      transcriptButtonChecked: false,
      kategorieButtonEnable: true,
      kategorieButtonChecked: false
    },
    {
      id: 'acco_kommentar',
      label: 'Kommentar',
      fudkeys: ['WebAnmerkung'],
      transcriptButtonEnable: false,
      transcriptButtonChecked: false,
      kategorieButtonEnable: false,
      kategorieButtonChecked: false
    },
    {
      id: 'acco_uebersetzung',
      label: 'Übersetzung',
      fudkeys: ['Übersetzung'],
      transcriptButtonEnable: true,
      transcriptButtonChecked: false,
      kategorieButtonEnable: true,
      kategorieButtonChecked: false
    },
    {
      id: 'acco_relation',
      label: 'Relation',
      fudkeys: ['WebRelation', 'WebVariante','WebRelationMerz','WebRelationAvantgarde','WebRelationWelt'],
      transcriptButtonEnable: true,
      transcriptButtonChecked: false,
      kategorieButtonEnable: true,
      kategorieButtonChecked: false
    },
    {
      id: 'acco_orte',
      label: 'Orte',
      fudkeys: ['index_ortsindex_7'],
      transcriptButtonEnable: true,
      transcriptButtonChecked: false,
      kategorieButtonEnable: true,
      kategorieButtonChecked: false
    },
    {
      id: 'acco_personen',
      label: 'Personen',
      fudkeys: ['index_personenindex_8'],
      transcriptButtonEnable: true,
      transcriptButtonChecked: false,
      kategorieButtonEnable: true,
      kategorieButtonChecked: false
    },
    {
      id: 'acco_seitenvorschau',
      label: 'Seitenvorschau',
      fudkeys: [],
      transcriptButtonEnable: false,
      transcriptButtonChecked: false,
      kategorieButtonEnable: false,
      kategorieButtonChecked: false
    },
    {
      id: 'acco_themen',
      label: 'Themen',
      fudkeys: ['index_ursonate_25'],
      transcriptButtonEnable: true,
      transcriptButtonChecked: false,
      kategorieButtonEnable: true,
      kategorieButtonChecked: false
    },
    {
      id: 'acco_elementebibliothek',
      label: 'Elemente-Bibliothek',
      fudkeys: ['WebAnmerkung', 'Übersetzung', 'WebRelation', 'WebVariante', 'index_personenindex_8','WebRelationMerz','WebRelationAvantgarde','WebRelationWelt'],
      transcriptButtonEnable: false,
      transcriptButtonChecked: false,
      kategorieButtonEnable: false,
      kategorieButtonChecked: false
    }
  ];

  export default SIDEBAR_MODEL;


// WEBPACK FOOTER //
// ./src/store/datamodel/sidebar.model.js